import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesByCityAndRelationController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesByCityAndRelationController.php
* @route '/api/place/city/{city}'
*/
const GetPlacesByCityAndRelationController = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlacesByCityAndRelationController.url(args, options),
    method: 'get',
})

GetPlacesByCityAndRelationController.definition = {
    methods: ["get","head"],
    url: '/api/place/city/{city}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesByCityAndRelationController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesByCityAndRelationController.php
* @route '/api/place/city/{city}'
*/
GetPlacesByCityAndRelationController.url = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return GetPlacesByCityAndRelationController.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesByCityAndRelationController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesByCityAndRelationController.php
* @route '/api/place/city/{city}'
*/
GetPlacesByCityAndRelationController.get = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlacesByCityAndRelationController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesByCityAndRelationController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesByCityAndRelationController.php
* @route '/api/place/city/{city}'
*/
GetPlacesByCityAndRelationController.head = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPlacesByCityAndRelationController.url(args, options),
    method: 'head',
})

export default GetPlacesByCityAndRelationController